<template>
	<div
		:class="
			'message card ' +
				(dropdownActive ? '' : 'hovershadow ') +
				(isOwn ? 'secondary2 ' : '') +
				(bodyRendered ? 'rendered' : '')
		"
		@contextmenu.exact.prevent="dropdownActive = true"
	>
		<div class="username_message-action" @contextmenu.exact.stop>
			<button
				v-if="!isFollowUp"
				class="username text-break btn link sm secondary"
			>
				<span>{{ message.userName || message.userId }}</span>
				<span class="invisible-text">:&nbsp;</span>
			</button>
			<Dropdown
				v-if="getMessageActions"
				class="message-action-dropdown"
				:items="getMessageActions"
				:align="isOwn ? 'right' : 'left'"
				@update:active="dropdownActive = $event"
				:active="dropdownActive"
			>
				<template v-slot:activator="scope">
					<button
						:class="
							'message-action-btn btn action link sm ' +
								(scope.active ? 'active ' : '')
						"
						@click.stop="scope.on()"
						@contextmenu.exact.prevent.stop="scope.on()"
					>
						<icon>dots-vertical</icon>
					</button>
				</template>
				<template v-slot:item="scope">
					<button
						:class="
							'message-action-dropdown-menu-li btn ' +
								(scope.item.classes || 'link')
						"
						@click.stop="dropdownAction(scope)"
						:disabled="scope.item.disabled"
					>
						{{
							typeof scope.item.name === 'function'
								? scope.item.name()
								: scope.item.name
						}}
					</button>
				</template>
			</Dropdown>
		</div>
		<div
			class="body text-break"
			v-html="rmsgbody"
			@contextmenu.exact.stop
		></div>
		<div class="timestamp-container" @contextmenu.exact.stop>
			<button class="timestamp btn link sm">
				<span class="invisible-text"
					>&nbsp;{{
						moment(message.dateAdded, 'x').format('M/D/Y')
					}}&nbsp;-&nbsp;</span
				>
				<span>{{
					moment(message.dateAdded, 'x').format('HH:mm:ss')
				}}</span>
			</button>
		</div>
	</div>
</template>

<script>
import Icon from './Icon';
import Dropdown from './Dropdown';
import { mapGetters } from 'vuex';
import moment from 'moment';

const escapeHtml = function(text) {
	let map = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		"'": '&#039;'
	};

	return text.replace(/[&<>"']/g, m => {
		return map[m];
	});
};

export default {
	name: 'Message',
	components: {
		Icon,
		Dropdown
	},
	props: ['message', 'isFollowUp', 'isOwn'],
	data() {
		return {
			rmsgbody: '',
			dropdownActive: false,
			bodyRendered: false
		};
	},
	mounted() {
		this.renderMsg();
	},
	computed: {
		getMessageActions() {
			if (!this.message) return null;

			const actionsGetter = this.$store.getters[
				'ConversationProviders/provider_' +
					this.message.providerName +
					'/messageActions'
			];

			if (!actionsGetter) return null;

			let actions = actionsGetter(this.message, {
				commit: this.$store.commit,
				dispatch: this.$store.dispatch
			});
			if (!actions) return null;

			// actions.unshift({
			//     name: (this.message.userName || this.message.userId) + ' - ' + this.message.key,
			//     disabled: true
			// });
			actions.push({
				name: 'Close'
			});

			return actions;
		},
		...mapGetters(['renderMsgBody', 'pluginFunctionalityRenderMsgBody'])
	},
	methods: {
		moment,
		renderMsg() {
			this.rmsgbody = escapeHtml(decodeURIComponent(this.message.body));

			this.renderMsgBody(this.message)().then(rmsgbody => {
				if (this.rmsgbody !== rmsgbody) {
					this.bodyRendered = true;
				}

				this.rmsgbody = rmsgbody;
			});
		},
		dropdownAction(scope) {
			if (!scope.item.keepOpen) scope.on();
			this.$nextTick(() => {
				if (scope.item.onclick) scope.item.onclick();
			});
		}
	},
	watch: {
		pluginFunctionalityRenderMsgBody(newval, oldval) {
			if (JSON.stringify(newval) !== JSON.stringify(oldval)) {
				this.renderMsg();
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.invisible-text {
	width: 0;
	height: 0;
	opacity: 0;
	white-space: nowrap;
	display: inline-block;
}
</style>
